// Needs-attention bucket logic (phase 23) — pure so the policy is testable.
// All dates are Melbourne-local YYYY-MM-DD strings; comparisons are plain
// string ordering (never toISOString().slice).

/** Why a lead is in the attention feed. Stale = follow-up overdue or
    missing entirely (Henry's pick, 2026-06-13). */
export type FollowupBucket = 'overdue' | 'today' | 'missing' | null;

export function leadFollowupBucket(followupDate: string | null, today: string): FollowupBucket {
  if (followupDate === null) return 'missing';
  if (followupDate < today) return 'overdue';
  if (followupDate === today) return 'today';
  return null;
}

/** Snoozed = hidden from Needs attention until the date arrives. The
    invoice row itself is untouched — still overdue in Finance. */
export function invoiceSnoozed(snoozedUntil: string | null, today: string): boolean {
  return snoozedUntil !== null && snoozedUntil > today;
}

/** Whole days from `iso` to `today` (positive = past). */
export function daysOverdue(iso: string, today: string): number {
  return Math.max(0, Math.round((Date.parse(today) - Date.parse(iso)) / 86_400_000));
}
